// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".search {\n  margin-top: 20px;\n  display: flex;\n  align-items: center;\n}\n.content-wrap .search .control-input .form-control {\n  padding-left: 15px;\n  height: 37px;\n}\n", ""]);
// Exports
module.exports = exports;
